import React, { useState, useEffect } from 'react';
import { Box, Typography, Slide } from '@mui/material';

/**
 * Shows a visual banner when running in a non-production environment.
 * Auto-hides after 4 seconds to avoid covering content on mobile.
 */
const DevBanner = () => {
  const env = process.env.REACT_APP_ENV;
  const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  // Only show in non-production environments
  if (!env || env === 'production') return null;

  const label = useEmulators ? `${env.toUpperCase()} (EMULATORS)` : env.toUpperCase();

  return (
    <Slide direction="down" in={visible} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          backgroundColor: useEmulators ? '#ff9800' : '#f44336',
          color: '#fff',
          textAlign: 'center',
          py: 0.25,
          fontSize: '0.75rem',
          pointerEvents: 'none',
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
          {label} ENVIRONMENT
        </Typography>
      </Box>
    </Slide>
  );
};

export default DevBanner;
